var React = require('react');

function AppliancesFridge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m86 94.3252784v17.6747216h-42.9999124v-17.6747216m-.0000876-46.3744659h42.9999124m-37.981635-5.7503296h10.0269168m11.4838163-19.062216h10.027793m-31.5385261 31.1596794h10.0269168m20.9454267 51.1110787h-28.9811542c-3.8709296 0-7.0093791-3.172681-7.0093791-7.0858317v-75.2373615c0-3.9131506 3.1384495-7.0858318 7.0093791-7.0858318h28.9811542c3.8709296 0 7.0093791 3.1726812 7.0093791 7.0858318v75.2373615c0 3.9131507-3.1384495 7.0858317-7.0093791 7.0858317z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

AppliancesFridge.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = AppliancesFridge;

AppliancesFridge.default = AppliancesFridge;
